import { createRoute, getPathForAllPortals } from "utilities/flatRoutes/routes";

export const preliminaryEstimatePath = "/PreliminaryEstimate";
export const preliminaryEstimateRoute = createRoute(
    getPathForAllPortals(preliminaryEstimatePath),
    "Preliminary Estimate",
);
